module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Outlet-29f7b45e322117afd374751219408bc7.svg";